import { logger } from '../../lib/logging'
import {
  GET_CURSOR_POSITION
} from '../actions'

const defaults = {
  section: {
    __typename: 'CurrentSection',
    id: null,
    state: null
  },
  insertScriptRes: {
    __typename: 'InsertScriptRes',
    isPending: false,
    error: ''
  },
  cursorPositions: [],
  cursorAcknowledged: true,
  contentToInsert: null
}

const resolvers = {
  Mutation: {
    section: (_, { id, state }, { cache }) => {
      const data = {
        section: {
          __typename: 'CurrentSection',
          id,
          state
        }
      }

      cache.writeData({ data })
      return null
    },
    setInsertScriptRes: (_, { isPending, error }, { cache }) => {
      const insertScriptRes = {
        __typename: 'InsertScriptRes'
      }

      if (isPending !== undefined) {
        insertScriptRes.isPending = isPending
      }

      if (error !== undefined) {
        insertScriptRes.error = error
      }

      const data = {
        insertScriptRes: insertScriptRes
      }

      cache.writeData({ data })
      return null
    },
    setCursorPosition: (_, { sectionId, cursorPositionIndex, location }, { cache }) => {
      const { cursorPositions: oldCursorPositions } = cache.readQuery({ query: GET_CURSOR_POSITION })

      const removeIdx = oldCursorPositions.findIndex(cp => cp.sectionId === sectionId)
      if (removeIdx > -1) oldCursorPositions.splice(removeIdx, 1)

      const newCPs = [
        ...oldCursorPositions,
        {
          __typename: 'CURSOR_POSITION',
          sectionId,
          cursorPositionIndex,
          location
        }
      ]

      const cursorPositions = {
        cursorPositions: newCPs
      }

      cache.writeData({ data: cursorPositions })
      return null
    },
    setCursorAcknowledged: (_, { isAcknowledged }, { cache }) => {
      const data = {
        cursorAcknowledged: isAcknowledged
      }
      logger.info(`[RESOLVER] Setting cursorAcknowledged to ${isAcknowledged}`)
      cache.writeData({ data })
      return null
    },
    setContentToInsert: (_, { contentToInsert }, { cache }) => {
      const data = {
        contentToInsert: contentToInsert
      }
      logger.info(`[RESOLVER] Setting content to insert to ${contentToInsert}`)
      cache.writeData({ data })
      return null
    }
  }
}

export default {
  defaults,
  resolvers
}
